
import { Component, Vue, Prop } from "vue-property-decorator";
import { DMT_TRANSFER_TYPE } from "@/constant";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader, EventBus } from "@/services/common";
@Component({})
export default class DMTConfirmationComponent extends Vue {
  public transferType = DMT_TRANSFER_TYPE;
  public transactionOTP = null;
  public otpError = null;
  @Prop() public data;

  public async proceedToPay() {
    console.log(this.transactionOTP)
    if(this.transactionOTP){

      let response = await Axios.post(
        API_STORE.SERVICE + 'dmtapi/verifyOtp',
        {
          mobileNumber:this.data.mobileNumber,
          otp:this.transactionOTP
        },
        {
          headers: getAPIAuthorizedHeader(),
        }
      );

      if(response.status == 200){
        this.otpError = null;
        this.$emit("updateDmtConfirmation", true);
      }else{
        this.otpError = "Something went wrong while verifying otp";
      }
    }else{
      this.otpError = "Enter OTP";
    }
  }
  public getTransferMode(transferMode) {
    return this.transferType.find((a) => a.value == transferMode).name;
  }

  resetForm() {
    this.$emit("cancel", true);
  }
}
